import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AddInstitutionComponent } from '@app/modules/vault/mx-component/dialog/add-institution/add-institution.component';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Observable, fromEvent } from 'rxjs';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DocumentService, UserService } from '@app/shared/services';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'create-mx-connect-form',
  templateUrl: './create-mx-connect-form.component.html',
  styleUrls: ['./create-mx-connect-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateMxConnectFormComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  isLoadingData = true;
  hidePopUp = false;
  mxDatList = [];
  forms;
  Form1;
  documentForm: UntypedFormGroup;
  vault_user_form_id;
  resizeObservable$: Observable<Event>;
  screenWidth: number;
  securityStateObject;
  loadOnce = true;
  userId;
  currentuserId;
  current_template;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  constructor(
    private MxconnectionService: MxconnectionService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private mxTaskbarService: MxTaskbarService,
    private toastr: ToastrService,
    private vaultService: VaultStoreEffects,

    private documentService: DocumentService,
    private store: Store,
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginStoreEffects,

    private userService: UserService,
    private dialogRef: MatDialogRef<AddInstitutionComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.userId = this.data.currentuserId;
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.loadOnce = false;
          }
        }
      })
    );
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
      })
    );

    this.documentForm = this.formBuilder.group({
      documentType: ['', Validators.required],
      documentName: ['', Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });

    this.current_template = this.forms.find((x) => x.type == this.data.description);
    this.Form1 = this.current_template.template;
    this.getuserData();
  }
  mouseEnterHandler(event: MouseEvent, assetExpansionPanel: MatExpansionPanel) {
    if (event.buttons && !assetExpansionPanel.expanded) {
      assetExpansionPanel.open();
    }
  }
  closeDialog() {
    this.dialogRef.close({
      success: true,
    });
  }
  getuserData(isRedirect = true) {
    this.subscription.add(
      this.MxconnectionService.getUserStatusMX(this.userId).subscribe((res) => {
        this.mxDatList = res.mx;
        if (isRedirect && (this.mxDatList == null || this.mxDatList == undefined || this.mxDatList?.length == 0)) {
          this.createMxConnect();
        }
        this.isLoadingData = false;
        this.cd.detectChanges();
      })
    );
  }
  createMxConnect() {
    this.hidePopUp = true;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: { currentValutUserId: this.userId },
    });
    this.subscription.add(
      dialogRef.componentInstance.mxDialogMinimized.subscribe((dialogId: string) => {
        this.hidePopUp = false;
        this.cd.detectChanges();
      })
    );
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        this.hidePopUp = false;
        if (val.success) {
          this.isLoadingData = true;
          this.getuserData(false);
        }
        this.cd.detectChanges();
      })
    );
  }
  createForm(item) {
    this.subscription.add(
      this.documentService
        .getforIdForFirstUploadDocument({
          user_id: this.currentuserId,
          vault_form_id: this.current_template.id,
          url: 'my-vault/0',
          source: 'onboarding',
        })
        .subscribe(
          (res) => {
            if (res.vault_user_form_id.vault_user_form_id) {
              this.vault_user_form_id = res.vault_user_form_id.vault_user_form_id;
              this.securityStateObject = res['vault_user_form_id'].public_key;
              this.saveForm(item);
              this.linkForm(item, this.vault_user_form_id);
            }

            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }

  linkForm(item, vault_user_form_id) {
    let fData = { guid: item.guid, vault_user_form_id: vault_user_form_id };
    this.subscription.add(this.userService.updateUserLinkedForm(fData).subscribe((val) => {}));
  }
  saveForm(name) {
    this.subscription.add(
      this.documentService
        .updateFormTampletData(
          {
            id: this.vault_user_form_id,
            form_name: name.name,
            status_progress: 'need to add',
            user_id: this.currentuserId,
            form_data: {
              beneFicaryForm: [],
              dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
              showNotes: undefined,
            },
            user_pk: this.securityStateObject.public_key,
          },
          null,
          undefined,
          undefined,
          false,
          undefined
        )
        .subscribe(
          (res) => {
            this.creatAsociateForm();
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  creatAsociateForm() {
    let payload = {
      user_id: +this.currentuserId,
      vault_user_form_id: this.data.vault_user_form_id,
      created_by_user_id: this.currentuserId,
      association_type: this.data?.manageType == 'Financial Account' ? 'account' : this.data?.manageType,
      source: 'onboarding',
      associate_vault_user_form_id: this.vault_user_form_id,
    };

    this.subscription.add(
      this.documentService.createUserFormAssociation(payload).subscribe((result) => {
        // refresh modal
        this.dialogRef.close({
          success: true,
        });
        this.cd.markForCheck();
      })
    );
  }
}
